import m from 'mithril';

const modal = {
  key: 'CARD_REQUEST_MODAL',

  show() {
    $(`#${modal.key}`).modal('show');
  },
  hide() {
    $(`#${modal.key}`).modal('hide');
  },
  oninit({ state }) {
    state.loading = false;

    state.cards = [
      {
        id: 1,
        title: 'Card 1',
        description: 'This is a sample card',
        type: 'individual',
        organization: {
          name: 'Organization A',
          logo: 'https://example.com/logo-a.png'
        }
      },
    ];

  },
  view({ state }) {
    return m('.modal.bg-body.fade', { id: modal.key },
      [
        m('.modal-dialog.modal-fullscreen[role="document"]',
          [
            m('.modal-content.shadow-none',
              [
                // m('.modal-header',
                //   [
                //     m('h1.modal-title', 'Modal Title (Probably through attrs)'),
                //     m('button.close[type="button" data-dismiss="modal" aria-label="close"', {
                //       onclick() {
                //         modal.hide();
                //       },
                //     },
                //     [
                //       m('span[aria-hidden="true"]', '×'),
                //     ]),
                //   ]),
                m('.modal-body.d-flex.flex-column.align-items-center',
                  [

                    

                    // m('img.card-img.top', { src: 'assets/media/illustrations/rubis-card.png', style: { "max-width": '30%', "height": 'auto', "padding-top": "200px" } }),
                    // [
                    //   m('.d-flex.justify-content-center.mb-3',{style:{"margin-top":"30px"}}, [
                    //     m('a.btn.btn-primary.mx-2', { href: 'https://selfregke.volanedev.com/self-registration?tab=2', _target:"blank" }, [
                    //       m('i.bi.bi-arrow-right.fs-1', [
                    //         m('span.path1'),
                    //         m('span.path2'),
                    //         m('span.path3'),
                    //         m('span.path4')
                    //       ]),
                    //       ' Individual '
                    //     ]),
                    //     m('a.btn btn-secondary.mx-2', { href: 'https://selfregke.volanedev.com/self-registration?tab=2', _target:"blank" }, [
                    //       m('i.bi.bi-arrow-right.fs-1', [
                    //         m('span.path1'),
                    //         m('span.path2'),
                    //         m('span.path3'),
                    //         m('span.path4')
                    //       ]),
                    //       ' Corporate '
                    //     ])
                    //   ])
                    // ]

                  ]),

              ]),
          ]),
      ]);
  },
};



// m('iframe', {
//   src: 'https://selfregke.volanedev.com/self-registration?tab=2', // add the iframe source URL here
//   style: {
//     "width": "95vw",
//     "height": "95vh",
//     "border": "none",
//     "border-radius": "10px"
//   }
// })


export default modal;
